<template>
	<div v-if="data.ready" :class="data.class" @click="hide_notification(0, 0)" ref="component">
		<div :class="'flash flash-' + data.status">
			<div class="title">
				<i v-if="data.withIcon && icons[data.status]" :class="icon"></i>
				{{ data.message }}
			</div>
		</div>
	</div>
</template>
<script>
export default {
	props: ['notification'],
	data() {
		return {
			icons: {
				success: 'check-circle',
				info: 'info-circle',
				error: 'times-circle',
				warning: 'warning',
			},
			data: {
				ready: false,
				status: 'success',
				message: '',
				timeout: 3000,
				class: 'flash-enter',
				autoHide: true,
				withIcon: true,
				callback: void 0,
			},
		}
	},
	methods: {
		hide_notification(a_t = 0, b_t = 0) {
			setTimeout(() => {
				this.data.class = 'flash-leave'
				setTimeout(() => {
					this.data.class = this.data.class += ' flash-leave-active'
					setTimeout(() => {
						this.$emit('leave', this.data)
					}, b_t)
				}, b_t)
			}, a_t)
		},
	},
	mounted() {
		this.data = Object.assign(
			{
				...this.data,
				ready: true,
			},
			this.notification
		)

		setTimeout(() => {
			this.data.class = this.data.class += ' flash-enter-active'
		}, 1000)

		if (this.data.autoHide) {
			this.hide_notification(parseInt(this.data.timeout) - 1000, 1000)
		}
	},
	computed: {
		icon() {
			return 'fa fa-' + (this.data.iconClass || this.icons[this.data.status] || 'check') + ' fa-lg mr-2'
		},
	},
}
</script>
